import { render, staticRenderFns } from "./LicenciaActual.vue?vue&type=template&id=3fea3cc8&"
import script from "./LicenciaActual.vue?vue&type=script&lang=ts&"
export * from "./LicenciaActual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports